import { api } from "./client";
import type { CheckSummary } from "./types";

export const listChecks = () => api<CheckSummary[]>("/api/checks");
export const getCheck = (id: string) => api<CheckSummary>(`/api/checks/${id}`);

export interface CheckPayload {
  name: string;
  priority: number;
  action_id: string;
  enabled: boolean;
  shop_system_label?: string | null;
  llm_verification_prompt?: string | null;
  // Free-text description of intent, read by the AI "Improve with AI" flow.
  brief?: string | null;
  // Which AI authoring agent variant tunes this check ("content" = word_index
  // only, "tech" = full toolset). Defaults to "content" on the backend.
  kind?: "content" | "tech";
  positive_rules: Array<Record<string, unknown>>;
  negative_rules: Array<Record<string, unknown>>;
}

export const createCheck = (body: CheckPayload) =>
  api<{ id: string }>("/api/checks", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const updateCheck = (id: string, body: CheckPayload) =>
  api<CheckSummary>(`/api/checks/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const deleteCheck = (id: string) =>
  api<CheckSummary>(`/api/checks/${id}`, { method: "DELETE" });

export const validateCheck = (body: Partial<CheckPayload>) =>
  api<{ ok: boolean; summary: Record<string, unknown> }>(
    "/api/checks/validate",
    { method: "POST", body: JSON.stringify(body) },
  );
